import { apiClient } from './apiClient.js';
import type { ApiResponse } from '@onboarding-dashboard/shared';
import type { FacilityConfig } from './missionControl.js';

export interface InsightsSurgeon {
  id: string;
  name: string;
  specialty: string;
  profiles: number;
  procedures: number;
}

export interface InsightsSegmentData {
  name: string;
  hasOutTime: boolean;
  inTime?: string;
  outTime?: string;
  duration?: number;
}

export interface InsightsWasteItem {
  name: string;
  count: number;
  cost: number;
}

export interface InsightsProcedure {
  id: string;
  name: string;
  surgeonId: string;
  surgeonName: string;
  roomName: string;
  startTime: string | null;
  totalTime: number;
  steps: number;
  stepsCompleted: number;
  segmentData: InsightsSegmentData[];
  wasteItems: InsightsWasteItem[];
}

export interface InsightsHeatmapCell {
  day: number;
  weekday: number;
  week: number;
  value: number;
}

export interface InsightsFacilityData {
  name: string;
  location: string;
  liveDate: string | null;
  totalSurgeons: number;
  totalProfiles: number;
  totalORs: number;
  recordedProcedures: number;
  supportedProcedures: number;
  specialties: string[];
  surgeons: InsightsSurgeon[];
  orRooms: string[];
  procedures: InsightsProcedure[];
  heatmap: { data: InsightsHeatmapCell[]; weeks: number } | null;
}

export const insightsService = {
  async getCommercialFacilities(): Promise<FacilityConfig[]> {
    const res: ApiResponse<FacilityConfig[]> =
      await apiClient.get<FacilityConfig[]>('/insights/facilities');
    if (!res.success || !res.data) return [];
    return res.data;
  },

  async getFacilityInsights(facilityId: string): Promise<InsightsFacilityData | null> {
    const res: ApiResponse<InsightsFacilityData> = await apiClient.get<InsightsFacilityData>(
      `/insights/facilities/${facilityId}`
    );
    if (!res.success || !res.data) return null;
    return res.data;
  },
};
